<template>
  <b-form-checkbox-group
    :id="`subCategories__${subCategory.id}`"
    v-model="selectedSubCategory"
    :options="[...subCategory.name]"
    :name="`subCategories__${subCategory.id}`"
    class="ml-4 mt-2"
    aria-label="Individual subCategories"
    stacked
    @change="toggleOption()"
  />
</template>

<script>
export default {
  name: 'FilterSubCategories',

  props: {
    subCategory: {
      type: Object,
      default: () => {}
    },
    subCategoriesOld: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selectedSubCategory: []
    };
  },

  computed: {
    isSelected() {
      return this.subCategory.is_selected;
    },
    /**
     * Check if incoming data from Edit includes existing object
     */
    checkIsSubCategorySelectedFromDB() {
      return this.subCategoriesOld.filter((sub_category) => {
        return sub_category.id === this.subCategory.id;
      });
    }
  },

  watch: {
    isSelected: {
      immediate: true,
      handler(isSelected) {
        if (isSelected) {
          this.selectedSubCategory = [this.subCategory.name];
        } else {
          this.selectedSubCategory = [];
        }
      }
    },

    /**
     * In case of open modal from Edit page
     *
     * If sub_category was selected before, set checkbox to true
     */
    subCategoriesOld: {
      immediate: true,
      handler() {
        if (this.checkIsSubCategorySelectedFromDB.length) {
          this.subCategory.is_selected = true;
        }
      }
    }
  },

  methods: {
    toggleOption() {
      this.subCategory.is_selected = !this.subCategory.is_selected;
    }
  }
};
</script>

<style lang="scss" scoped></style>
